import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { environment } from 'environments/environment';
import { UserService } from 'shared/services/User/user.service';
import { Headers, Http } from '@angular/http';

@Injectable()
export class VendorsService {
  token: any;

  constructor(
    private http: Http,
    private userService: UserService
  ) { 
    
    this.token = this.userService.user.token; 
  
  }

  ticketmasterGetAccountByID(accountID, team_id) {
    const userParams = new FormData();
    const headers = new Headers();
    headers.append('token', this.token);
    userParams.append('acct_id', accountID);
    userParams.append('team_id', team_id);
    return this.http.post(environment.API_BASE_URL + '/vendors/ticketmaster/lookup', userParams, { headers: headers }).map(res => {
      return res.json();
    })
      .catch(err => {
        return Observable.throw(err.json());
      });
  }

  uploadTicketmaster(data) {
    const headers = new Headers();
    headers.append('token',  this.token);
    const userParams: FormData = new FormData();
    userParams.append('res_ref', data.res_ref);
    userParams.append('plan_ref', data.plan_ref);
    userParams.append('group_size', data.group_size);
    userParams.append('first_seat', data.first_seat);
    userParams.append('last_seat', data.last_seat);
    userParams.append('num_seats', data.num_seats);
    userParams.append('payment_enabled', String(data.payment_enabled));
    userParams.append('group_type', data.group_type);
    userParams.append('is_next_season', data.next_season);
    userParams.append('games_to_share_count', data.games_to_share_count);
    userParams.append('split_type_id', data.split_type_id);
    userParams.append('custom_games_selected', data.custom_games_selected);
    userParams.append('filter_flag', data.flag_string);
    return this.http.post(environment.API_BASE_URL + '/vendors/ticketmaster/upload', userParams, { headers: headers }).map(res => {
      return res.json();
    }, err => {
      return Observable.throw(err.json());
    });
  }

  connectAccount(authToken, team_id){
    const userParams: FormData = new FormData();
    userParams.append('auth_token', authToken); 
    userParams.append('team_id', team_id); 
    const headers = new Headers()
    headers.append('token', this.userService.user.token)
    return this.http.post(environment.API_BASE_URL + '/vendors/ticketmaster/authcodev2', userParams, { headers: headers }).map(res => {
      return res.json();
    }, err => {
      return Observable.throw(err.json());
    });
  }

  getTeamAccount(team_id){
    const userParams: FormData = new FormData();
    const headers = new Headers()
    headers.append('token', this.userService.user.token)
    userParams.append('team_id', team_id)
    return this.http.post(environment.API_BASE_URL + '/vendors/ticketmaster/teamAccount', userParams, { headers: headers }).map(res => {
      return res.json();
    }, err => {
      return Observable.throw(err.json());
    });
  }

  removeTeamAccountv2(teamId, accountId){
    const userParams: FormData = new FormData();
    userParams.append('team_id', teamId)
    userParams.append('account_id', accountId)
    const headers = new Headers()
    headers.append('token', this.userService.user.token)
    return this.http.post(environment.API_BASE_URL + '/vendors/ticketmaster/removeTeamAccount', userParams, { headers: headers }).map(res => {
      return res.json();
    }, err => {
      return Observable.throw(err.json());
    });
  }

  getWidgetUrlByTeamName(teamId){
    return this.http.get(`https://ss-node-api.herokuapp.com/teamAuth/url/${teamId}`).map(res => {
      return res.json();
    }, err => {
      return Observable.throw(err.json());
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/SS-vendors/vendors.service.ts